import { FieldErrors } from 'react-hook-form';

import { FormInputsType } from '../@types';

export const sanitizeErrors = (errors: FieldErrors<FormInputsType>) => (
  Object.fromEntries(Object.entries(errors).map(([key, val]) => ([key, val?.message])))
);

export const unpackErrorMessage = (
  errors: FieldErrors<FormInputsType>,
  name: string,
) => (errors[name] ? errors[name]?.message ? errors[name]?.message : true : false);
